export default "__VITE_ASSET__BfM2ver3__"